/**
 * Dialog ベースの確認 UI でユーザーがキャンセルした際にスローされるエラー
 */
export class ConfirmCancelledError extends Error {
  constructor(message = "User cancelled the confirmation dialog") {
    super(message);
    this.name = "ConfirmCancelledError";

    // TypeScriptでのExtendsエラーのためのプロトタイプチェーン修正
    Object.setPrototypeOf(this, ConfirmCancelledError.prototype);
  }
}
